import CartItemRegistration from './cart-item-registration';

export default CartItemRegistration;
